import { Fragment, useState } from "react";
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/react";
import { createFileRoute } from "@tanstack/react-router";
import { tv } from "tailwind-variants";

import { Accordion, focusRing, Heading, MarkdownRenderer } from "@/ui";
import {
  cannabisAndCancerSymptoms,
  cannabisAndPain,
  cannabisAndSleep,
  cannabisAndStress,
  MobileTabMenu,
} from "./-components";

const cannabis101Variants = tv({
  slots: {
    tab: `flex min-h-11 items-center rounded-md px-2 text-lg transition-colors ${focusRing}`,
  },
  variants: {
    selected: {
      true: {
        tab: "font-bold text-accent",
      },
      false: {
        tab: "cursor-pointer text-content-secondary hover:text-accent",
      },
    },
  },
});

const { tab: tabClass } = cannabis101Variants();

export const cannabis101 = [
  cannabisAndPain,
  cannabisAndSleep,
  cannabisAndStress,
  cannabisAndCancerSymptoms,
];

const Cannabis101 = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div className="flex flex-col items-center px-5 py-8 text-content sm:px-6 sm:py-20">
      <div className="flex w-full max-w-4xl flex-col">
        <Heading className="mb-6 border-b border-line pb-3 md:pb-6" level={1}>
          Cannabis 101
        </Heading>

        <MobileTabMenu
          className="lg:hidden"
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
        />

        <TabGroup onChange={setSelectedIndex} selectedIndex={selectedIndex}>
          <div className="hidden justify-between text-lg lg:flex">
            <TabList className="flex gap-x-1">
              {cannabis101.map((tab, index) => {
                return (
                  <Fragment key={index}>
                    <Tab className={tabClass}>{tab.title}</Tab>

                    <span className="px-0.5 text-lg text-content-subtle last:hidden">|</span>
                  </Fragment>
                );
              })}
            </TabList>
          </div>

          <TabPanels>
            {cannabis101.map((section, index) => {
              return (
                <TabPanel key={index}>
                  <Accordion.Root
                    className="flex flex-col"
                    defaultValue={section.information[0].id.toString()}
                    type="single"
                    collapsible
                  >
                    <p className="my-8 text-content-secondary">{section.subtitle}</p>
                    {section.information.map((info) => {
                      return (
                        <Accordion.Item key={info.id} value={info.id.toString()}>
                          <Accordion.Header>
                            <Accordion.Trigger>
                              {info.title}
                              <Accordion.Icon />
                            </Accordion.Trigger>
                          </Accordion.Header>
                          <Accordion.Content>
                            <MarkdownRenderer>{info.body}</MarkdownRenderer>
                          </Accordion.Content>
                        </Accordion.Item>
                      );
                    })}
                  </Accordion.Root>
                </TabPanel>
              );
            })}
          </TabPanels>
        </TabGroup>

        <p className="mt-4 sm:mt-20">
          The content on this page is for informational purposes. Do not attempt to self-diagnose or
          prescribe treatment based on the information provided. Always consult a physician before
          deciding on the treatment of a medical condition.
        </p>
      </div>
    </div>
  );
};

export const Route = createFileRoute("/_private/(with-footer)/cannabis-101/")({
  component: Cannabis101,
});
